import { useDispatch, useSelector } from "react-redux";
import {
  setIsReviewRegularizationScreen,
  setPendingRegularization,
} from "../../store/reducers/regularizationSlice";
import ReusableRegularization from "../Regularization/resuableRegularization";
import regularizationAdminDoneIcon from "../../Icons/regularizationAdminDoneIcon.svg";
import { useGetEmployeeListQuery } from "../../api/addEmployeeApi";

const ReviewRegularization = () => {
  const dispatch = useDispatch();
  const dashboardRegulaarizationData = useSelector(
    (state) => state.dashBoardReview?.regularizations
  );
  const { data: usersList } = useGetEmployeeListQuery();
  dispatch(setIsReviewRegularizationScreen(true));
  dispatch(setPendingRegularization(dashboardRegulaarizationData));

  return (
    <>
      <div className="w-[97%] mx-5">
        {dashboardRegulaarizationData.length === 0 ? (
          <div className="flex flex-col gap-5 items-center justify-center text-center pt-10 h-[90%] w-full">
            <img alt="NoData" width="400px" src={regularizationAdminDoneIcon} />
            <p className="font-medium text-lg">
              {
                "Youre all caught up! No active regularization requests at the moment."
              }
            </p>
          </div>
        ) : (
          dashboardRegulaarizationData.map((each) => (
            <ReusableRegularization
              key={each.id}
              data={each}
              shouldShowApplyRejectButtons={true}
              isReviewCard = {true}
              usersList={usersList}
            />
          ))
        )}
      </div>
    </>
  );
};

export default ReviewRegularization;
